/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ExpiringSoonCard_company = {
    readonly upcomingExpirations: {
        readonly edges: ReadonlyArray<{
            readonly delegateUUID: string;
            readonly delegateName: string;
            readonly itemName: string;
            readonly expiryDate: string;
        } | null> | null;
    };
    readonly " $refType": "ExpiringSoonCard_company";
};
export type ExpiringSoonCard_company$data = ExpiringSoonCard_company;
export type ExpiringSoonCard_company$key = {
    readonly " $data"?: ExpiringSoonCard_company$data;
    readonly " $fragmentRefs": FragmentRefs<"ExpiringSoonCard_company">;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "ExpiringSoonCard_company",
    "type": "Company",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "upcomingExpirations",
            "storageKey": "upcomingExpirations(page:{\"limit\":80})",
            "args": [
                {
                    "kind": "Literal",
                    "name": "page",
                    "value": {
                        "limit": 80
                    }
                }
            ],
            "concreteType": "UpcomingExpirationPage",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UpcomingExpiration",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "delegateUUID",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "delegateName",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "itemName",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "expiryDate",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = '4df88383c3d48a78a12ba40669ae30ce';
export default node;
